// extracted by mini-css-extract-plugin
export default {"outer":"MyAccountSidebar_outer__mMsQ7","mobile":"MyAccountSidebar_mobile__NGlL4"};